<template>
	<div
		class="id-main-container d-flex align-items-center justify-content-center"
	>
	<div
			style="position: fixed; z-index: 1; left: 60px;"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div v-else class="id-main-white-container d-flex flex-column align-items-center">
			<img
				src="../assets/img/interviewdetails/h3xlogo.svg"
				class="text-center my-4"
				alt=""
			/>
			<div
				class="id-image-conatiner d-flex align-items-center justify-content-center w-100"
			>
				<img :src="content.image" />
			</div>

			<h3
				:class="[
					content.titleClass,
					content.titleClass === 'id-accepted'
						? 'color-accepted'
						: content.titleClass === 'id-rejected' ||
						  content.titleClass === 'id-alreadyrejected'
						? 'color-rejected'
						: 'text-blue',
				]"
				class="fw-500 fs-24 fam-lato d-flex align-items-center mt-4 mb-3 mob-fs-16 mob-text-center"
			>
				<img
					src="../assets/img/interviewdetails/greentick.svg"
					class="mr-2"
					v-if="content.titleClass === 'id-accepted'"
					alt=""
				/>
				<img
					src="../assets/img/interviewdetails/redcross.svg"
					class="mr-2"
					v-if="content.titleClass === 'id-rejected'"
					alt=""
				/>
				{{ content.title }}
			</h3>

			<p
				class="fw-500 fam-lato fs-18 text-darkgrey mb-4 mob-fs-14 idmob-p mob-text-center"
				v-html="content.description"
			></p>
		</div>
	</div>
</template>

<script>
import { rescheduleInterviewAction } from "@/utils/apiFunctions";
import Spinner from "@/components/fixedcomponents/Spinner.vue";

export default {
	data() {
		return {
			interviewData: {},
			LoaderStatus: false,
			status: null, 
			scheduledTime: null,
		};
	},
	components: {Spinner},
	created(){
		this.LoaderStatus = true;
		this.getInterviewData();
	},
	computed: {
		content() {
			return {
				accepted: {
					image: require("@/assets/img/interviewdetails/interviewaccepted.svg"),
					title: "Interview Accepted!",
					titleClass: "id-accepted",
					description: `Your interview is scheduled at <b>${this.scheduledTime}</b>.`,
				},
				alreadyAccepted: {
					image: require("@/assets/img/interviewdetails/interviewaccepted.svg"),
					title: "You have already accepted the interview!",
					titleClass: "id-alreadyaccepted",
					description: `Your interview is scheduled at <b>${this.scheduledTime}</b>.`,
				},
				rejected: {
					image: require("@/assets/img/interviewdetails/interviewcancelled.svg"),
					title: "Interview Rejected!",
					titleClass: "id-rejected",
					description:
						"Please await further communication from our team regarding the next steps.",
				},
				alreadyRejected: {
					image: require("@/assets/img/interviewdetails/interviewcancelled.svg"),
					title: "You have already rejected the interview!",
					titleClass: "id-alreadyrejected",
					description:
						"Please await further communication from our team regarding the next steps.",
				},
			}[this.status];
		},
	},
	methods:{
		async getInterviewData(){
			try {
			  let payload = {
				id : this.$route.query.id,
				action : parseInt(this.$route.query.action)
			  }
			  const res = await rescheduleInterviewAction(payload);
			  if(res.status == 200 || res.status == 208){
				this.interviewData = res.data.data.data;
				if(res.status == 208) this.status = this.interviewData.status == 'accepted' ? 'alreadyAccepted' : 'alreadyRejected';
				else this.status = this.interviewData.status;
				this.scheduledTime = `${this.interviewData.indianFormattedDte}, ${this.interviewData.indianFormattedTime}`
			  }
			  else {
				this.$router.push({
						path: "/404",
					});
			  }
			} catch (error) {
				console.error(error);
				this.$router.push({
						path: "/404",
					});
			} finally{
				this.LoaderStatus = false;
			}
		}
	}
};
</script>

<style>
.id-main-container {
	width: 100%;
	height: 100vh;
	background: rgba(52, 64, 84, 0.2);
	backdrop-filter: blur(8px);
}

.id-main-white-container {
	width: 842px;
	background: #ffffff;
	border-radius: 16px;
}
.id-image-conatiner {
	padding: 24px 264px;
	height: 229px;
	background: #e2f3ff;
	border-radius: 0px 0px 8px 8px;
}
.color-accepted {
	color: #038e00;
}
.color-rejected {
	color: #e40000;
}
@media (max-width: 1028px) {
	.id-main-white-container {
		width: 100%;
	}
	.id-image-conatiner {
		padding: 0;
	}
	.id-main-container {
		padding: 15px;
	}
	.idmob-p {
		padding: 0 15px;
	}
	.mob-text-center {
		text-align: center;
	}
}
</style>
